import React, { Component } from "react";
import { connect } from 'react-redux';
import { withStyles } from 'material-ui/styles';
import Stepper, { Step, StepLabel } from 'material-ui/Stepper';
import Typography from 'material-ui/Typography';

const styles = (theme) => ({
  root: {
    padding: theme.spacing.unit,
    marginBottom: theme.spacing.unit * 2,
  }
});

class ApplicationStepper extends Component {
  stepIndex = () => {
    const { application } = this.props;
    return ['loan', 'borrower', 'personal', 'confirmation'].indexOf(application.step);
  }

  render = () => {
    const { classes } = this.props;
    if (this.props.application) {
      return (
        <Stepper classes={{root: classes.root}} activeStep={this.stepIndex()}>
          <Step>
            <StepLabel> Loan Details </StepLabel>
          </Step>
          <Step>
            <StepLabel> Borrower Details </StepLabel>
          </Step>
          <Step>
            <StepLabel> Director/Guarantor Details </StepLabel>
          </Step>
        </Stepper>
      );
    }
  }
}

const mapStateToProps = (state) => {};

const styled = withStyles(styles)(ApplicationStepper);
const connected = connect(mapStateToProps)(styled);
export default connected;



// WEBPACK FOOTER //
// ./src/containers/Application/stepper.js